import {Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy} from '@angular/core';
import {NewsService} from '../../../shared/services/news.service';
import {AppLoadingEventsEmitter} from '../../../shared/events/loading.events';
import {NewsViewModel} from '../../../shared/viewModels/news.viewModel';
import {Constants} from '../../../shared/config/constants.config';
import {Router} from '@angular/router';

@Component({
    selector: 'app-news',
    templateUrl: './news.component.html',
    styleUrls: ['./news.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewsComponent implements OnInit {
    news: NewsViewModel[] = [];
    skip = 0;
    hasMore = false;

    constructor(
        private readonly newsService: NewsService,
        private readonly changeDetectorRef: ChangeDetectorRef,
        private readonly appLoadingEventsEmitter: AppLoadingEventsEmitter,
        private readonly constants: Constants,
        public readonly router: Router,
    ) {
    }

    ngOnInit() {
        this.loadMore();
    }

    loadMore() {
        this.appLoadingEventsEmitter.broadcastAppIsLoading(true);

        this.newsService.getNews(this.skip).subscribe(news => {
            news.map(item => {
                this.news.push(item);
            });

            this.skip += news.length;
            console.log(this.skip);
            this.hasMore = news.length >= 8;

            this.appLoadingEventsEmitter.broadcastAppIsLoading(false);
            this.changeDetectorRef.markForCheck();
        });
    }

}
